export const LinkIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.56322 12.3801L5.86776 11.0759C6.21367 10.73 6.80917 10.9599 6.8271 11.4486C6.8498 12.0796 6.96455 12.704 7.16774 13.3018C7.20249 13.4018 7.20846 13.5096 7.18497 13.6128C7.16147 13.7161 7.10946 13.8106 7.03486 13.8857L6.5747 14.3459C5.5904 15.3302 5.55877 16.9353 6.53427 17.9315C6.7686 18.1701 7.04782 18.3598 7.35585 18.49C7.66388 18.6201 7.99461 18.6879 8.32898 18.6896C8.66335 18.6912 8.99475 18.6267 9.30406 18.4997C9.61337 18.3726 9.89447 18.1856 10.1312 17.9495L12.4921 15.5861C12.9664 15.1115 13.2328 14.468 13.2328 13.797C13.2328 13.126 12.9664 12.4825 12.4921 12.0078C12.3801 11.8968 12.2584 11.796 12.1286 11.7066C12.0561 11.657 11.9962 11.591 11.9538 11.5141C11.9114 11.4372 11.8876 11.3514 11.8843 11.2636C11.8767 11.0698 11.9095 10.8765 11.9805 10.696C12.0516 10.5155 12.1593 10.3517 12.297 10.215L13.0373 9.47681C13.1314 9.38316 13.2556 9.32569 13.3879 9.31451C13.5202 9.30332 13.6522 9.33913 13.7607 9.41564C14.3997 9.86175 14.9333 10.4422 15.3243 11.1162C15.7153 11.7903 15.9542 12.5417 16.0242 13.3178C16.0942 14.0939 15.9937 14.8759 15.7297 15.6091C15.4657 16.3422 15.0445 17.0088 14.4958 17.5621L14.4831 17.5751L12.1208 19.9374C10.0373 22.0209 6.64747 22.0206 4.56287 19.9374C2.47828 17.8542 2.47969 14.4633 4.56322 12.3801Z"
        fill="#CBD5E1"
      />
      <path
        d="M17.4251 10.654C18.4094 9.66972 18.441 8.06462 17.4655 7.06837C17.2312 6.82988 16.9519 6.64015 16.6438 6.51011C16.3358 6.38006 16.005 6.31229 15.6707 6.31069C15.3363 6.30909 15.0049 6.37369 14.6956 6.50078C14.3863 6.62786 14.1053 6.81491 13.8686 7.05115L11.5077 9.41381C11.0334 9.88842 10.767 10.5319 10.767 11.2029C10.767 11.8739 11.0334 12.5175 11.5077 12.9921C11.6197 13.1031 11.7414 13.2039 11.8712 13.2933C11.9436 13.343 12.0034 13.4089 12.0458 13.4858C12.0881 13.5627 12.1119 13.6485 12.1152 13.7363C12.1229 13.9301 12.0902 14.1234 12.0192 14.3039C11.9482 14.4844 11.8405 14.6482 11.7028 14.7849L10.9625 15.5249C10.8683 15.6184 10.7442 15.6759 10.6119 15.6871C10.4796 15.6982 10.3476 15.6625 10.239 15.586C9.59984 15.1399 9.06593 14.5594 8.67475 13.8852C8.28357 13.211 8.04459 12.4594 7.97456 11.6831C7.90453 10.9067 8.00514 10.1245 8.26934 9.39114C8.53354 8.6578 8.95494 7.99112 9.50399 7.43783L9.51665 7.42483L11.879 5.06252C13.9625 2.97898 17.3523 2.97933 19.4369 5.06252C21.5215 7.14571 21.5205 10.5359 19.4369 12.6205L18.1324 13.9247C17.7865 14.2706 17.191 14.0407 17.1731 13.5521C17.1504 12.921 17.0356 12.2967 16.8324 11.6988C16.7977 11.5988 16.7917 11.491 16.8152 11.3878C16.8387 11.2846 16.8907 11.19 16.9653 11.1149L17.4251 10.654Z"
        fill="#CBD5E1"
      />
    </svg>
  );
};

export const ChartIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2409 10.1888C14.7724 10.5792 14.2778 10.6053 13.7572 10.2669L9.54017 7.1041L4.03463 11.4383C3.74829 11.6725 3.43592 11.7767 3.09752 11.7506C2.78514 11.6986 2.51182 11.5294 2.27754 11.243C2.06929 10.9827 1.97819 10.6834 2.00422 10.345C2.05628 10.0326 2.21246 9.75926 2.47277 9.52498L8.7202 4.52704C9.21479 4.16261 9.72239 4.14959 10.243 4.488L14.46 7.6898L19.9656 3.27756C20.2519 3.06931 20.5513 2.9782 20.8636 3.00423C21.202 3.05629 21.4754 3.21248 21.6836 3.47279C21.9179 3.75913 22.022 4.0715 21.996 4.4099C21.9439 4.72227 21.7747 4.9956 21.4884 5.22988L15.2409 10.1888ZM8.25164 11.7506C8.25164 11.3862 8.36878 11.0868 8.60306 10.8526C8.83734 10.6183 9.13669 10.5011 9.50113 10.5011C9.86556 10.5011 10.1649 10.6183 10.3992 10.8526C10.6335 11.0868 10.7506 11.3862 10.7506 11.7506V19.2475C10.7506 19.612 10.6335 19.9113 10.3992 20.1456C10.1649 20.3799 9.86556 20.497 9.50113 20.497C9.13669 20.497 8.83734 20.3799 8.60306 20.1456C8.36878 19.9113 8.25164 19.612 8.25164 19.2475V11.7506ZM3.2537 15.4991C3.2537 15.1346 3.37084 14.8353 3.60512 14.601C3.8394 14.3667 4.13875 14.2496 4.50319 14.2496C4.86762 14.2496 5.16697 14.3667 5.40125 14.601C5.63553 14.8353 5.75267 15.1346 5.75267 15.4991V19.2475C5.75267 19.612 5.63553 19.9113 5.40125 20.1456C5.16697 20.3799 4.86762 20.497 4.50319 20.497C4.13875 20.497 3.8394 20.3799 3.60512 20.1456C3.37084 19.9113 3.2537 19.612 3.2537 19.2475V15.4991ZM15.7486 14.2496V19.2475C15.7486 19.612 15.6314 19.9113 15.3971 20.1456C15.1629 20.3799 14.8635 20.497 14.4991 20.497C14.1346 20.497 13.8353 20.3799 13.601 20.1456C13.3667 19.9113 13.2496 19.612 13.2496 19.2475V14.2496C13.2496 13.8852 13.3667 13.5858 13.601 13.3515C13.8353 13.1173 14.1346 13.0001 14.4991 13.0001C14.8635 13.0001 15.1629 13.1173 15.3971 13.3515C15.6314 13.5858 15.7486 13.8852 15.7486 14.2496ZM18.2475 11.7506C18.2475 11.3862 18.3647 11.0868 18.5989 10.8526C18.8332 10.6183 19.1326 10.5011 19.497 10.5011C19.8614 10.5011 20.1608 10.6183 20.3951 10.8526C20.6293 11.0868 20.7465 11.3862 20.7465 11.7506V19.2475C20.7465 19.612 20.6293 19.9113 20.3951 20.1456C20.1608 20.3799 19.8614 20.497 19.497 20.497C19.1326 20.497 18.8332 20.3799 18.5989 20.1456C18.3647 19.9113 18.2475 19.612 18.2475 19.2475V11.7506Z"
        fill="#A1A1AA"
      />
    </svg>
  );
};

export const CheckIcon = ({ fill = "#A1A1AA" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_4322)">
        <path
          d="M11.4281 15.9281C10.9172 16.4391 10.0828 16.4391 9.57187 15.9281L6.57187 12.9281C6.06094 12.4172 6.06094 11.5828 6.57187 11.0719C7.08281 10.5609 7.91719 10.5609 8.42813 11.0719L10.5 13.1437L15.5719 8.07187C16.0828 7.56094 16.9172 7.56094 17.4281 8.07187C17.9391 8.58281 17.9391 9.41719 17.4281 9.92813L11.4281 15.9281ZM24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12ZM12 2.25C6.61406 2.25 2.25 6.61406 2.25 12C2.25 17.3859 6.61406 21.75 12 21.75C17.3859 21.75 21.75 17.3859 21.75 12C21.75 6.61406 17.3859 2.25 12 2.25Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_4322">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CrossIcon = ({ fill = "#A1A1AA" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_4336)">
        <path
          d="M8.20312 8.20312C8.64375 7.76719 9.35625 7.76719 9.75469 8.20312L11.9578 10.4109L14.2031 8.20312C14.6438 7.76719 15.3563 7.76719 15.7547 8.20312C16.2328 8.64375 16.2328 9.35625 15.7547 9.75469L13.5891 11.9578L15.7547 14.2031C16.2328 14.6438 16.2328 15.3563 15.7547 15.7547C15.3563 16.2328 14.6438 16.2328 14.2031 15.7547L11.9578 13.5891L9.75469 15.7547C9.35625 16.2328 8.64375 16.2328 8.20312 15.7547C7.76719 15.3563 7.76719 14.6438 8.20312 14.2031L10.4109 11.9578L8.20312 9.75469C7.76719 9.35625 7.76719 8.64375 8.20312 8.20312ZM24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12ZM12 2.25C6.61406 2.25 2.25 6.61406 2.25 12C2.25 17.3859 6.61406 21.75 12 21.75C17.3859 21.75 21.75 17.3859 21.75 12C21.75 6.61406 17.3859 2.25 12 2.25Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_4336">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InfoIcon = ({ fill = "#A1A1AA" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C9.75 0.03125 7.73438 0.578125 5.95312 1.64062C4.14062 2.70312 2.70312 4.14062 1.64062 5.95312C0.578125 7.73438 0.03125 9.75 0 12C0.03125 14.25 0.578125 16.2656 1.64062 18.0469C2.70312 19.8594 4.14062 21.2969 5.95312 22.3594C7.73438 23.4219 9.75 23.9688 12 24C14.25 23.9688 16.2656 23.4219 18.0469 22.3594C19.8594 21.2969 21.2969 19.8594 22.3594 18.0469C23.4219 16.2656 23.9688 14.25 24 12C23.9688 9.75 23.4219 7.73438 22.3594 5.95312C21.2969 4.14062 19.8594 2.70312 18.0469 1.64062C16.2656 0.578125 14.25 0.03125 12 0ZM12 21.75C9.25 21.6875 6.95312 20.7344 5.10938 18.8906C3.26562 17.0469 2.3125 14.75 2.25 12C2.3125 9.25 3.26562 6.95312 5.10938 5.10938C6.95312 3.26562 9.25 2.3125 12 2.25C14.75 2.3125 17.0469 3.26562 18.8906 5.10938C20.7344 6.95312 21.6875 9.25 21.75 12C21.6875 14.75 20.7344 17.0469 18.8906 18.8906C17.0469 20.7344 14.75 21.6875 12 21.75ZM13.875 15.75H13.125V11.625C13.0625 10.9375 12.6875 10.5625 12 10.5H10.5C9.8125 10.5625 9.4375 10.9375 9.375 11.625C9.4375 12.3125 9.8125 12.6875 10.5 12.75H10.875V15.75H10.125C9.4375 15.8125 9.0625 16.1875 9 16.875C9.0625 17.5625 9.4375 17.9375 10.125 18H13.875C14.5625 17.9375 14.9375 17.5625 15 16.875C14.9375 16.1875 14.5625 15.8125 13.875 15.75ZM12 9C12.4375 9 12.7969 8.85938 13.0781 8.57812C13.3594 8.29688 13.5 7.9375 13.5 7.5C13.5 7.0625 13.3594 6.70312 13.0781 6.42188C12.7969 6.14062 12.4375 6 12 6C11.5625 6 11.2031 6.14062 10.9219 6.42188C10.6406 6.70312 10.5 7.0625 10.5 7.5C10.5 7.9375 10.6406 8.29688 10.9219 8.57812C11.2031 8.85938 11.5625 9 12 9Z"
        fill={fill}
      />
    </svg>
  );
};

export const ExportIcon = ({ fill = "#A1A1AA" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.59998 5.99999C3.59998 4.67451 4.67449 3.59999 5.99998 3.59999H7.19998C7.86272 3.59999 8.39998 4.13725 8.39998 4.79999C8.39998 5.46274 7.86272 5.99999 7.19998 5.99999L5.99998 5.99999V18H18V5.99999H16.8C16.1372 5.99999 15.6 5.46274 15.6 4.79999C15.6 4.13725 16.1372 3.59999 16.8 3.59999H18C19.3255 3.59999 20.4 4.67451 20.4 5.99999V18C20.4 19.3255 19.3255 20.4 18 20.4H5.99998C4.67449 20.4 3.59998 19.3255 3.59998 18V5.99999Z"
        fill={fill}
      />
      <path
        d="M4.79998 14.4H8.39998L9.59998 16.8H14.4L15.6 14.4H19.2V19.2H4.79998V14.4Z"
        fill={fill}
      />
      <path
        d="M8.75145 8.75147C9.22008 8.28284 9.97987 8.28284 10.4485 8.75147L10.8 9.10294V3.59999C10.8 2.93725 11.3372 2.39999 12 2.39999C12.6627 2.39999 13.2 2.93725 13.2 3.59999V9.10294L13.5514 8.75147C14.0201 8.28284 14.7799 8.28284 15.2485 8.75147C15.7171 9.2201 15.7171 9.97989 15.2485 10.4485L12.8485 12.8485C12.6235 13.0736 12.3182 13.2 12 13.2C11.6817 13.2 11.3765 13.0736 11.1514 12.8485L8.75145 10.4485C8.28282 9.97989 8.28282 9.2201 8.75145 8.75147Z"
        fill={fill}
      />
    </svg>
  );
};
export const ClockIcon = ({ fill = "#A1A1AA" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9996 22C17.5225 22 21.9996 17.5228 21.9996 12C21.9996 6.47712 17.5225 1.99997 11.9996 1.99997C6.47679 1.99997 1.99963 6.47712 1.99963 12C1.99963 17.5228 6.47679 22 11.9996 22ZM12.9992 6.99996C12.9992 6.44767 12.5515 5.99996 11.9992 5.99996C11.4469 5.99996 10.9992 6.44767 10.9992 6.99996V12C10.9992 12.2652 11.1046 12.5195 11.2921 12.7071L14.8277 16.2426C15.2182 16.6331 15.8513 16.6331 16.2419 16.2426C16.6324 15.8521 16.6324 15.2189 16.2419 14.8284L12.9992 11.5857V6.99996Z"
        fill="#A1A1AA"
      />
    </svg>
  );
};
export const ReloadIcon = ({ fill = "#A1A1AA" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#FFFFFF"
    >
      <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
    </svg>
  );
};
export const CalendarIcon = ({ fill = "#A1A1AA" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#FFFFFF"
    >
      <path d="M320-400q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm160 0q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm160 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
    </svg>
  );
};
